'use client';

import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";
import { ChevronLeft, ChevronRight } from "lucide-react";

import { SubCategory } from "../../../types";
import ServiceCategoryRow, {
    ServiceCategoryRowProps,
} from "../service-category-row/ServiceCategoryRow";

type ServiceCategoryRowCarouselProps = {
    categories: SubCategory[];
    classes?: string;

    /* Swiper behaviour */
    infinite?: boolean;
    autoplay?: boolean;
    autoplayDelay?: number;

    /* Child presentation control */
    rowProps?: Omit<ServiceCategoryRowProps, "category">;
};

// TODO THIS COMPONENT IS BROKEN AND NEEDS TO BE REWRITTEN
export default function ServiceCategoryRowCarousel({
                                                       categories,
                                                       classes = "",
                                                       infinite = false,
                                                       autoplay = false,
                                                       autoplayDelay = 5000,
                                                       rowProps = {},
                                                   }: ServiceCategoryRowCarouselProps) {
    return (
        <div className={`relative w-full min-w-0 ${classes}`}>
            <Swiper
                modules={[Navigation, Autoplay]}
                slidesPerView={1}
                spaceBetween={30}
                speed={600}
                loop={infinite}
                allowTouchMove
                navigation={{
                    nextEl: ".service-row-next",
                    prevEl: ".service-row-prev",
                }}
                autoplay={
                    autoplay
                        ? {
                            delay: autoplayDelay,
                            disableOnInteraction: false,
                            pauseOnMouseEnter: true,
                        }
                        : false
                }
                className="service-category-row-swiper w-full min-w-0"
            >
                {categories.map((category) => (
                    <SwiperSlide
                        key={category.id}
                        className="w-full !h-auto min-w-0"
                    >
                        <div className="w-full max-w-7xl mx-auto min-w-0">
                            <ServiceCategoryRow
                                category={category}
                                {...rowProps}
                            />
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            {/* Navigation */}
            <button
                className="service-row-prev absolute left-2 top-1/2 -translate-y-1/2 z-10
                   flex h-[45px] w-[45px] items-center justify-center
                   rounded-full bg-black/60 text-white
                   hover:bg-black transition"
                aria-label="Previous slide"
            >
                <ChevronLeft className="h-6 w-6" />
            </button>

            <button
                className="service-row-next absolute right-2 top-1/2 -translate-y-1/2 z-10
                   flex h-[45px] w-[45px] items-center justify-center
                   rounded-full bg-black/60 text-white
                   hover:bg-black transition"
                aria-label="Next slide"
            >
                <ChevronRight className="h-6 w-6" />
            </button>
        </div>
    );
}
